import script from "./CategoryTreeNode.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryTreeNode.vue?vue&type=script&setup=true&lang=js"

import "./CategoryTreeNode.vue?vue&type=style&index=0&id=13510ed4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13510ed4"]])

export default __exports__